import { n$2, t$2, e$2, u$1, i$1, r$1 } from '@/js/global/global'
import { AnimateProductItem } from '@/js/global/animations'
import { dispatchCustomEvent } from '@/js/global/helpers'
import { getProduct, ProductForm } from '@/js/global/product-methods'
import { cart } from '@/js/global/cart'

const selectors$K = {
  item: ".product-item",
  itemInner: ".product-item__inner",
  quickViewButton: ".show-product-quickview",
  addToCart: "[data-add-to-cart]",
  quickCart: ".quick-cart",
  purchaseConfirmation: ".purchase-confirmation-popup",
  link: ".fs-product-card-title a",
};

function ProductItem(container) {
  const items = t$2(selectors$K.item, container);

  if (!items.length) return;

  // Add z-index for quick-buy overlap
  items.forEach((item, i) => {
    item.style.setProperty("--z-index-item", items.length - i)
    item.addEventListener('click', (event) => {
      if (!event.target || (event.target.tagName !== 'A' && event.target.tagName !== 'BUTTON')) {
        const href = item.querySelector(selectors$K.link).getAttribute('href');
        if (href) window.location.href = href;
      }
    })
  });

  const productItemAnimations = AnimateProductItem(items);
  const quickViewButtons = t$2(selectors$K.quickViewButton, container);
  const addToCartButtons = t$2(selectors$K.addToCart, container);

  const onFormSubmit = (e) => {
    const formElement = e.target;
    const purchaseConfirmation = n$2(selectors$K.purchaseConfirmation, document);
    const quickCart = n$2(selectors$K.quickCart, document);
    const isQuickViewForm = Boolean(e.target.closest(".quick-product"));

    // if quick cart and confirmation popup are enable submit form
    if (!purchaseConfirmation && !quickCart && !isQuickViewForm) return;

    e.preventDefault();

    const button = n$2(selectors$K.addToCart, formElement);

    u$1(button, "loading");

    cart.addItem(formElement).then(_ref4 => {
      let {
        item
      } = _ref4;

      i$1(button, "loading");

      if (purchaseConfirmation) {
        r$1("confirmation-popup:open", null, {
          product: item
        });
      } else {
        r$1("quick-cart:updated");

        // Need a delay to allow quick-cart to refresh
        setTimeout(() => {
          r$1("quick-cart:open");
        }, 300);
      }
      dispatchCustomEvent("cart:item-added", {
        product: item
      });
    }).catch(error => {
      console.log(error);
      cart.get(); // update local cart data

      const button = n$2(selectors$K.addToCart, formElement);

      i$1(button, "loading");
    });
  }

  const events = [
    e$2(quickViewButtons, "click", e => {
      e.preventDefault();
      e.stopPropagation();

      const linkEl = e.currentTarget;
      const url = linkEl.getAttribute("data-href");

      r$1("quick-view:open", null, {
        productUrl: url,
        trigger: e.currentTarget,
      });
    }),

    e$2(addToCartButtons, "click", e => {
      e.preventDefault();

      const productForm = e.currentTarget.closest('form');
      const {
        productHandle
      } = productForm.dataset;

      const product = getProduct(productHandle);

      product(data => {
        ProductForm(container, productForm, data, {
          onFormSubmit: e => onFormSubmit(e)
        });

        productForm.dispatchEvent(new Event('submit'));
      });
    })
  ];

  const unload = () => {
    productItemAnimations.destroy();
    events.forEach(unsubscribe => unsubscribe());
  };

  return {
    unload
  };
}

export { ProductItem }